import { useTranslation } from "react-i18next";
import image1 from "./assets/image1.png";
import image2 from "./assets/image2.png";
import image3 from "./assets/image3.png";
import image4 from "./assets/image4.png";
import { ContentCarouselData } from "@components/slider/smooth-carousel/ContentCarousel";











export function useLanguageSlide(){

  const { i18n, t } = useTranslation();


  return [
    { 
      url: image1, 
      title: t("widgets.company_photo_carousel.slide1.title"), 
      description : t("widgets.company_photo_carousel.slide1.description")
    },
    { 
      url: image2, 
      title: t("widgets.company_photo_carousel.slide2.title"), 
      description :t("widgets.company_photo_carousel.slide2.description")
    },
    { 
      url: image3, 
      title: t("widgets.company_photo_carousel.slide3.title"), 
      description :t("widgets.company_photo_carousel.slide3.description")
    },
    { 
      url: image4, 
      title: t("widgets.company_photo_carousel.slide4.title"), 
      description : t("widgets.company_photo_carousel.slide4.description")
    },
  ] as const satisfies Readonly<ContentCarouselData>[];

}